import config from 'config';
import Model from 'lib/Model';
import { v4 as uuid } from 'uuid';
import * as repo from 'db/repositories';

export default Model.extend({
	url: config.url.user,
	file: config.file.user,

	defaults: function()
	{
		return {
			uuid: uuid()
		};
	},

	initialize: function()
	{
		// Après sauvegarde du mot de passe, l'effacer !
		this.on('sync',function()
		{
			this.unset('password');
			this.unset('confirm');
		});
	},

	toString: function() {
		return 'mon compte utilisateur';
	},

	getLastModified: function() { return 0; },

	validate: function( attrs, options )
	{
		var error = {};

		if( !_.isString( attrs.email ) )
		{
			error.email = "Veuillez fournir une adresse email";
		}
		else if( !attrs.email.match( /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/ ) )
		{
			error.email = "Veuillez fournir une adresse email valide";
		}

		if( _.isNumber( attrs.zip ) )
		{
			attrs.zip = attrs.zip.toString();
		}

		if( !_.isString( attrs.zip ) )
		{
			error.zip = "Veuillez fournir un code postal";
		}
		else if( !attrs.zip.match( /(\d{2}|2[AB])\s?\d{3}/ ) )
		{
			error.zip = "Le code postal fourni ne semble pas correct";
		}
		else if ( !repo.findByZip( attrs.zip.replace( /\s/g, '' ) ) )
		{
			error.zip = "Ce code postal n'existe pas…";
		}

		if( !attrs.id && !attrs.password )
		{
			error['password'] = 'Ce champ est obligatoire';
		}

		if( attrs.password && attrs.password.length < 8 )
		{
			error['password'] = 'Ce champ doit faire plus de 8 caractères';
		}

		if( attrs.password && attrs.password != attrs.confirm )
		{
			error['confirm'] = "La confirmation du mot de passe n'est pas valide";
		}

		if( _.size( error ) > 0 )
		{
			return error;
		}
	},

	parse: function( attrs )
	{
		if( attrs && attrs.token )
		{
			delete attrs.token;
		}

		if( _.isObject( attrs.config ) )
		{
			_.each( attrs.config, function( val, key )
			{
				attrs[ 'config_' + key ] = val;
			});
			delete attrs.config;
		}
		return attrs;
	},

	toJSON: function()
	{
		var attrs = { config: {} };
		_.each( this.attributes, function( val, key )
		{
			if( key.substr( 0, 7 ) == 'config_' )
			{
				attrs.config[ key.substr( 7 ) ] = val;
			}
			else
			{
				attrs[key] = val;
			}
		});
		return attrs;
	}

});
